import { BannerBlock } from 'src/types/contentBlocks';

import { ContainersInstruction } from './ContainersInstruction';
import { FreeCoursesAndCertification } from './FreeCoursesAndCertification';

export function Banner(props: BannerBlock['data']) {
  const { variant } = props;

  switch (variant) {
    case 'FreeCoursesAndCertification':
      return <FreeCoursesAndCertification {...props} />;
    case 'ContainersInstruction':
      return <ContainersInstruction {...props} />;
    default:
      return null;
  }
}
